import { MatDialog } from '@angular/material/dialog';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SwiperOptions } from 'swiper';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { ExpandImageDialogComponent } from 'src/app/modules/store/expand-image-dialog/expand-image-dialog.component';
import { CommonFunctions } from '../../common-functions';
import { MenuService } from '../../services/menu.service';
import { Router } from '@angular/router';
SwiperCore.use([Pagination, Navigation]);
@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent implements OnInit {
  @Input() smallDevices;
  @Input() sliderData;
  @Input() noOfpannel;
  @Input () baristaInfo;
  @Input() itemType;
  @Input() item;
  @Input() isPanelOpened;
  @Input() isPanelOpened1;
  @Input() isPanelOpened2;
public vegtext = 'Vegetarian'
  public wordLimit: number;
  public showMore: boolean = false;
  public verifyLogin: boolean;
  public isPhone: boolean;
  public isMobile:boolean;
  constructor(
    private dialog: MatDialog,
    public commonFunctions: CommonFunctions,
    private router:Router,
    public menuService: MenuService,
  ) {
    this.isMobile= this.commonFunctions.identifyDeviceType();
  }
  ngOnInit(): void {
    this.isPhone = JSON.parse(sessionStorage.getItem('isMobile'));
    this.verifyLogin = this.commonFunctions.verifyLoggedInUser();
    this.isPhone ? (this.wordLimit = 100) : (this.wordLimit = 300);
  }
  config: SwiperOptions = {
    allowTouchMove: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: true,
    },
  };
  ngOnChanges(changes: SimpleChanges) {
  }
  data = [
    {
      id: 1,
      img: 'assets/images/DSC00176 3.png',
    },
    {
      id: 1,
      img: 'assets/images/DSC00176 3.png',
    },
  ];
  expandImage(img: any) {
    const dialogRef = this.dialog.open(ExpandImageDialogComponent, {
      width: '600px',
      height: '500px',
      panelClass: 'dialog-no-padding',
      data: { storeImage: img },
    });
  }
  @Output() saveTo = new EventEmitter<any>();
  addToFav(item) {
    item['isFavourite'] = !item['isFavourite'];
    let obj = {
      item,
      isFav: item['isFavourite'],
    };
    this.saveTo.emit(obj);
  }
  @Output() setToDefault = new EventEmitter<any>();
  setDefault(){
    this.setToDefault.emit(true);
  }
  gotoPrevius(){
    //this._location.back();
    this.router.navigate(['/ordering']);
  }
  @Output() closePanels = new EventEmitter<any>();
  closeAllPanels(){
    this.closePanels.emit(true);
  }
}
